import { ReactNode } from "react";

import LinkButton from "ds/components/Button/LinkButton";
import Feedback from "ds/components/Feedback";
import FeedbackActions from "ds/components/Feedback/Actions";
import { FeedbackType, FeedbackVariant } from "ds/components/Feedback/types";
import { AnalyticsPageGlobal } from "hooks/useAnalytics/pages/global";
import useTypedContext from "hooks/useTypedContext";
import { BillingTierFeature } from "types/generated";
import useTierFeature from "views/Account/hooks/useTierFeature";
import { SubscriptionContext } from "views/Account/SubscriptionWrapper";
import { AccountContext } from "views/AccountWrapper";

type TierInfoProps = {
  feature: BillingTierFeature;
  type?: FeedbackType;
  variant: FeedbackVariant;
  children: ReactNode;
  title?: string;
  className?: string;
  adminActionText?: string;
  notAdminTextPlaceholder?: string;
  storageKey?: string;
};

const TierInfo = ({
  feature,
  title,
  children,
  className,
  type = "callout",
  variant = "danger",
  adminActionText = "Upgrade",
  notAdminTextPlaceholder = "Ask your admin to upgrade.",
  storageKey,
}: TierInfoProps) => {
  const { viewer } = useTypedContext(AccountContext);
  const { tier } = useTypedContext(SubscriptionContext);

  const isActive = useTierFeature(feature);

  if (isActive) return null;

  return (
    <Feedback
      title={title}
      variant={variant}
      className={className}
      type={type}
      storageKey={storageKey}
    >
      {children}
      <FeedbackActions>
        {viewer.admin ? (
          <LinkButton
            variant="contrast"
            size="small"
            to="/settings/billing"
            analyticsPage={AnalyticsPageGlobal.UpgradePlanBanner}
            analyticsTitle="Upgrade Button Clicked"
            analyticsProps={{
              buttonText: adminActionText,
              billingTierFeature: feature,
              currentTier: tier,
              variant,
              type,
            }}
          >
            {adminActionText}
          </LinkButton>
        ) : (
          notAdminTextPlaceholder
        )}
      </FeedbackActions>
    </Feedback>
  );
};

export default TierInfo;
